import http from "./httpOrganization";
import toTitle from "../../util/util";
const request_type = {
  show: "get",
  update: "put",
  store: "post",
  delete: "delete",
  list: "get",
};

export default class BaseService {
  uri = "";
  method = "";
  form = {};
  relationship;
  selected_rel = "";
  requests;

  constructor(id, relationship, resource) {
    this.id = id ? `/${id}` : "";
    this.relationship = relationship;
    this.resource = resource;
    let base = `${this.uri}/${this.resource}${this.id}`;
    Object.keys(relationship).map((index) => {
      this.generateRelationships(index, base);
    });
    Object.keys(request_type).map((index) => this.assignMethods(base, index));
  }

  generateRelationships(index, base) {
    const rel = this.relationship[index];
    Object.keys(request_type).map((key) => {
      this.assignMethods(base, `${index}${toTitle(key)}`, rel);
    });
  }

  assignMethods(base, index, rel) {
    return Object.assign(BaseService.prototype, {
      [index]: this.generateRequests(base, index, rel),
    });
  }

  generateRequests(base, index, rel) {
    let resource = index.split(/(?=[A-Z])/);
    resource = resource[1]?.toLowerCase() || "";
    if (
      Object.keys(request_type)
        .map((j) => j)
        .includes(index) ||
      Object.keys(request_type)
        .map((j) => j)
        .includes(resource) ||
      index.endsWith("Store")
    ) {
      return (form = {}) => {
        this.generateURI(base, index, null, rel);
        return this.checkParams(form);
      };
    }
    return (args = "", form = {}) => {
      this.generateURI(base, index, args, rel);
      return this.checkParams(form);
    };
  }

  async checkParams(form) {
    if (form && this.method == "get") form = { params: { ...form } };
    if (JSON.stringify(form) != "{}" && this.method == "delete") {
      this.uri = this.uri + form;
      return http[this.method](this.uri);
    }
    return http[this.method](this.uri, form);
  }

  generateURI(base, index, args, rel) {
    let resource = index.split(/(?=[A-Z])/);
    let endpoint = this.relationship[1];
    this.method = request_type[this.checkTypeResource(index)];
    this.selected_rel = rel;
    let baseRel = args
      ? `${base}/${this.selected_rel}/${args}`
      : `${base}/${this.selected_rel}`;
    this.uri = resource.length == 1 ? base : baseRel;
  }

  checkTypeResource(resource) {
    let checked;
    Object.keys(request_type).map((j) => {
      let res = resource.toLowerCase().match(j);
      if (res) checked = res[0];
    });
    return checked;
  }
}
